import {
    TvvActie,
    TvvAfschalingBesteldeRouteActie,
    TvvStopBesteldeRouteActie,
    TvvWijzigBesteldeRouteActie,
    VestigingActieType,
} from "@/entities/actie";
import { ActieDto } from "@/shared/types";
import { BusEvacuatieActie, BusEvacuatieGeannuleerdActie } from "./bus-evacuatie.ts";
import { OpstartplanActie } from "./opstartplan.ts";
import { PrognoseActie } from "./prognose.ts";
import { ReikwijdteGewijzigdActie } from "./reikwijdte-gewijzigd.ts";
import { TrajectenGewijzigdActie } from "./trajecten-gewijzigd.ts";
import { TvvRouteBesteldActie } from "./tvv-route.ts";
import {
    LandelijkeFaciliteitenAangevraagdActie,
    LandelijkeFaciliteitenStopAangevraagdActie,
    VestigingenAangevraagdActie,
    VestigingenStopAangevraagdActie,
    VestigingenVerlengingAangevraagdActie,
} from "./vestigingen.ts";
import { VsmActie } from "./vsm.ts";

export type Actie =
    | PrognoseActie
    | OpstartplanActie
    | VsmActie
    | BusEvacuatieActie
    | BusEvacuatieGeannuleerdActie
    | VestigingenAangevraagdActie
    | VestigingenStopAangevraagdActie
    | LandelijkeFaciliteitenAangevraagdActie
    | LandelijkeFaciliteitenStopAangevraagdActie
    | VestigingenVerlengingAangevraagdActie
    | TvvRouteBesteldActie
    | TvvWijzigBesteldeRouteActie
    | TvvAfschalingBesteldeRouteActie
    | TvvStopBesteldeRouteActie
    | TrajectenGewijzigdActie
    | ReikwijdteGewijzigdActie;
export const Actie = {
    isVestigingActie: (actie: Actie): boolean => Object.values(VestigingActieType).includes(actie.type as VestigingActieType),
    isLandelijkeFaciliteitenActie: (actie: Actie): boolean =>
        ["LandelijkeFaciliteitenAangevraagd", "LandelijkeFaciliteitenStopAangevraagd"].includes(actie.type),
    isBusEvacuatieActie: (actie: Actie): actie is BusEvacuatieActie =>
        actie.type === "BusEvacuatie" || actie.type === "AnnuleerBusEvacuatieActie",
    isVsmActie: (actie: Actie): actie is VsmActie => actie.type === "Vsm",
    isTvvActie: (actie: Actie): actie is TvvActie =>
        ["TvvBesteldeRoute", "TvvWijzigBesteldeRoute", "TvvStopBesteldeRoute", "TvvAfschalingBesteldeRoute"].includes(actie.type),
    fromDto: (dto: ActieDto): Actie => {
        switch (dto.type) {
            case "Prognose":
                return PrognoseActie.fromDto(dto);
            case "Opstartplan":
                return OpstartplanActie.fromDto(dto);
            case "Vsm":
                return VsmActie.fromDto(dto);
            case "BusEvacuatie":
                return BusEvacuatieActie.fromDto(dto);
            case "AnnuleerBusEvacuatieActie":
                return BusEvacuatieGeannuleerdActie.fromDto(dto);
            case "VestigingenAangevraagd":
                return VestigingenAangevraagdActie.fromDto(dto);
            case "VestigingenStopAangevraagd":
                return VestigingenStopAangevraagdActie.fromDto(dto);
            case "LandelijkeFaciliteitenAangevraagd":
                return LandelijkeFaciliteitenAangevraagdActie.fromDto(dto);
            case "LandelijkeFaciliteitenStopAangevraagd":
                return LandelijkeFaciliteitenStopAangevraagdActie.fromDto(dto);
            case "VestigingenVerlengingAangevraagd":
                return VestigingenVerlengingAangevraagdActie.fromDto(dto);
            case "TvvBesteldeRoute":
                return TvvRouteBesteldActie.fromDto(dto);
            case "TvvStopBesteldeRoute":
                return TvvStopBesteldeRouteActie.fromDto(dto);
            case "TvvWijzigBesteldeRoute":
                return TvvWijzigBesteldeRouteActie.fromDto(dto);
            case "TvvAfschalingBesteldeRoute":
                return TvvAfschalingBesteldeRouteActie.fromDto(dto);
            case "TrajectenGewijzigd":
                return TrajectenGewijzigdActie.fromDto(dto);
            case "ReikwijdteGewijzigd":
                return ReikwijdteGewijzigdActie.fromDto(dto);
        }
    },
};
